import React from 'react'
import { Box, Card, CardBody, Heading as DSHeading } from '@homebotapp/hb-react-component-catalog'

const Heading = ({ children }) => (
  <DSHeading size='sm' textAlign='left'>
    {children}
  </DSHeading>
)

const Body = ({ children }) => (
  <Card size='lg' overflow='hidden'>
    <CardBody padding={4}>{children}</CardBody>
  </Card>
)

const Section = ({ children }) => {
  const sections = {
    heading: null,
    body: null
  }

  React.Children.forEach(children, child => {
    if (!child) return
    switch (child.type) {
      case Heading: {
        sections.heading = child
        break
      }
      case Body: {
        sections.body = child
        break
      }
      default:
        sections.body = child
        break
    }
  })

  return (
    <Box mt={8}>
      {sections.heading}
      {sections.body}
    </Box>
  )
}

export default Object.assign(Section, { Heading, Body })
